<template>
    <div class="flex flex-column justify-content-center align-items-center w-full h-full" v-if="canShow">
        <Form class="form">
            <h2 class="H5-SemiBold mb-2 text-center mt-8">Personal Information</h2>
            <div class="grid w-full align-items-center justify-content-center pt-4">
                <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-3 pt-4">
                        <label for="firstName" class="Label align-self-start">First Name</label>
                        <IconField class="w-full">
                            <InputIcon class="pi pi-user" />
                            <InputText id="firstName" name="firstName" type="text" disabled
                                placeholder="Enter first name here" size="small" variant="filled" class="w-full"
                                v-model="userProfile.firstName" />
                        </IconField>
                    </div>
                    <div class="flex flex-column gap-3 pt-4">
                        <label for="email" class="Label align-self-start">Email</label>
                        <IconField class="w-full">
                            <InputIcon class="pi pi-envelope" />
                            <InputText id="email" name="email" type="email" disabled placeholder="Enter email here"
                                size="small" variant="filled" class="w-full" v-model="userProfile.email" />
                        </IconField>
                    </div>

                    <div class="flex flex-column gap-3 pt-4">
                        <label for="NIC" class="Label align-self-start">NIC</label>
                        <IconField class="w-full">
                            <InputIcon class="pi pi-id-card" />
                            <InputText id="NIC" name="NIC" type="text" disabled placeholder="Enter NIC here"
                                size="small" variant="filled" class="w-full" v-model="userProfile.NIC" />
                        </IconField>
                    </div>
                </div>

                <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-3 pt-4">
                        <label for="lastName" class="Label align-self-start">Last Name</label>
                        <IconField class="w-full">
                            <InputIcon class="pi pi-user" />
                            <InputText id="lastName" name="lastName" type="text" disabled
                                placeholder="Enter last name here" size="small" variant="filled" class="w-full"
                                v-model="userProfile.lastName" />
                        </IconField>
                    </div>
                    <div class="flex flex-column gap-3 pt-4">
                        <label for="phone" class="Label align-self-start">Mobile Number</label>
                        <IconField class="w-full">
                            <InputIcon class="pi pi-phone" />
                            <InputText id="phone" name="phone" type="tel" disabled
                                placeholder="Enter mobile number here" size="small" variant="filled" class="w-full"
                                v-model="userProfile.mobileNumber" />
                        </IconField>
                    </div>
                    <div class="flex flex-column gap-3 pt-4">
                        <label for="address" class="Label align-self-start">Address</label>
                        <IconField class="w-full">
                            <InputIcon class="pi pi-map-marker" />
                            <InputText id="address" name="address" type="text" disabled placeholder="Enter address here"
                                size="small" variant="filled" class="w-full" v-model="userProfile.address" />
                        </IconField>
                    </div>
                </div>

                <div class="col-12 md:col-4">
                    <div class="flex flex-column gap-3 pt-4">
                        <label for="dob" class="Label align-self-start">Date of Birth</label>
                        <IconField class="w-full">
                            <InputIcon class="pi pi-calendar" />
                            <DatePicker v-model="date" dateFormat="dd/mm/yy" disabled showIcon fluid iconDisplay="input"
                                variant="filled" size="small" class="w-full" />
                        </IconField>
                    </div>
                </div>

                <div class="col-12 md:col-4">
                    <div class="flex flex-column gap-3 pt-4">
                        <label for="gender" class="Label align-self-start">Gender</label>
                        <Select v-model="selectGender" :options="gender" variant="filled" size="small" disabled
                            option-label="label" option-value="value" placeholder="Select your gender" class="w-full" />
                    </div>
                </div>

                <div class="col-12 md:col-4">
                    <div class="flex flex-column gap-3 pt-4">
                        <label for="nationality" class="Label align-self-start">Nationality</label>
                        <NationalitySelect id="nationality" :model-value="userProfile?.nationality" label=""
                            placeholder="Select your nationality" :disabled="true" :show-clear="false" />
                    </div>
                </div>

                <div class="col-12 col-6  flex flex-column  gap-3">
                    <label for="bio" class="Label align-self-start">Bio</label>
                    <IconField class="w-full w-full flex align-items-start">
                        <InputIcon class="pi pi-file " />
                        <Textarea v-model="userProfile.tutorBio" variant="filled" autoResize rows="5" disabled cols="30"
                            class="w-full" />
                    </IconField>
                </div>
            </div>
            <h2 class="H5-SemiBold mt-8 mb-4 text-center">Teaching Informations</h2>
            <div class="grid w-full pt-4">
                <div class="col-12 ">
                    <div class="flex flex-column gap-3 pt-2">
                        <label for="grades" class="Paragraph-Medium align-self-start">Grade and subjects</label>
                        <div class="teaching-table px-2 md:px-6">
                            <div v-for="(group, gIndex) in groupedTeachingLevels" :key="gIndex" class="teaching-grade-block mb-3">
                                <div v-for="(entry, eIndex) in group.entries" :key="entry.subject" class="teaching-row">
                                    <!-- Grade: shown only on the first subject row -->
                                    <div class="teaching-col-grade">
                                        <span v-if="eIndex === 0" class="Label">{{ cleanupLables(group.grade) }}</span>
                                    </div>
                                    <!-- Subject -->
                                    <div class="teaching-col-subject">
                                        <span class="Paragraph-Regular">{{ cleanupLables(entry.subject) }}</span>
                                    </div>
                                    <!-- Pricing -->
                                    <div class="teaching-col-price">
                                        <div v-if="entry.individualClass?.available" class="price-line">
                                            <span class="price-type Paragraph-Regular">Individual</span>
                                            <span class="price-value Paragraph-Regular">Rs. {{ formatPrice(entry.individualClass.charge) }}</span>
                                        </div>
                                        <div v-if="entry.groupClass?.available" class="price-line">
                                            <span class="price-type Paragraph-Regular">Group</span>
                                            <span class="price-value Paragraph-Regular">Rs. {{ formatPrice(entry.groupClass.charge) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-12 md:col-6 p-0 pr-3">
                <div class=" flex flex-column gap-3 pt-4 ">
                    <label for="occupation" class="Paragraph-Medium align-self-start">I’m a : {{
                        cleanupLables(userProfile.tutorType) }}</label>
                </div>
            </div>
            <div class="grid w-full">
                <div class="col-12 md:col-6">
                    <div class=" flex flex-column gap-3 pt-4">
                        <label for="subjects" class="Paragraph-Medium align-self-start">I do classes : 
                            {{ cleanupLables(selectedClassType) }}</label>
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-3 pt-4 justify-content-center align-items-center lg:px-4">
                        <!-- <label for="locations" class="Paragraph-Medium align-self-start">Class location:</label> -->

                        <!-- <RadioButtonGroup v-model="userProfile.classLocation" name="location"
                            class="flex flex-column gap-2">
                            <div class="flex flex-wrap gap-2">
                                <RadioButton size="small" inputId="tutors_place" disabled value="tutors_place"
                                    class="teal-radio-button" />
                                <label class="Paragraph-Regular" for="tutors_place">Tutor’s place</label>
                            </div>
                            <div class="flex flex-wrap gap-2">
                                <RadioButton size="small" inputId="students_place" disabled value="students_place"
                                    class="teal-radio-button" />
                                <label class="Paragraph-Regular" for="students_place">Student’s place</label>
                            </div>
                            <div class="flex flex-wrap gap-2">

                                <RadioButton size="small" inputId="both" disabled value="both"
                                    class="teal-radio-button" />
                                <label class="Paragraph-Regular" for="both">Both</label>
                            </div>
                        </RadioButtonGroup> -->


                    </div>
                </div>

                <div class="col-12 md:col-6 p-0">
                    <div class="flex flex-column gap-3 pt-4">
                        <label for="occupation" class="Paragraph-Medium align-self-start">My teaching
                            language/s:</label>
                        <div class="flex justify-content-center">
                            <CheckboxGroup v-model="userProfile.teachingLanguage" name="item"
                                class="flex flex-column gap-2">
                                <div v-for="item in languages" :key="item.key" class="flex items-center gap-2">
                                    <Checkbox :inputId="item.key" :value="item.key" disabled class="teal-checkbox" />
                                    <label class="Paragraph-Regular" :for="item.key">{{ item.value }}</label>
                                </div>
                            </CheckboxGroup>
                        </div>

                    </div>
                    <div class="flex flex-column gap-3 pt-4">
                        <label class="Paragraph-Medium align-self-start">I'm available in:</label>
                        <div class="flex justify-content-center">
                            <CheckboxGroup v-model="userProfile.teachingAvailability" name="availability"
                                class="flex flex-column gap-2">
                                <div v-for="item in availabilityOptions" :key="item.key"
                                    class="flex items-center gap-2">
                                    <Checkbox :inputId="item.key" :value="item.key" disabled class="teal-checkbox" />
                                    <label class="Paragraph-Regular" :for="item.key">{{ item.value }}</label>
                                </div>
                            </CheckboxGroup>
                        </div>

                    </div>
                </div>
            </div>
            <h2 class="H5-SemiBold mt-8 mb-4 text-center">Teaching Experiences & Qualifications</h2>
            <div class="grid w-full pt-4">
                <div class="col-12">
                    <label class="Paragraph-Medium align-self-start flex ">Previous Experiences</label>
                    <div class="grid mt-2 gap-1 flex justify-content-center">
                        <div v-for="(exp, index) in userProfile.experience" :key="index" class="col-12 md:col-6 ">
                            <div class="grid">
                                <div class="col-5 flex align-items-center">
                                    <span class="Label">{{ exp.institution }}</span>
                                </div>
                                <div class="col-7 flex align-items-center">
                                    <span class="Label">{{ exp.yearsOfExperience }} Years</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <label class="Paragraph-Medium align-self-start flex">Highest Education</label>
                    <div class="grid mt-2 gap-1 flex justify-content-center">
                        <div v-for="(edu, index) in userProfile.highestEducation" :key="'edu-' + index"
                            class="col-12 md:col-6">
                            <div class="grid">
                                <div class="col-6 flex align-items-center">
                                    <span class="Label">{{ edu.education }}</span>
                                </div>
                                <div class="col-6 flex align-items-center" v-if="edu.certificationURL">
                                    <Button label="Uploaded" class="teal-button-transparent"
                                        @click="downloadByUrl(edu.certificationURL)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <label class="Paragraph-Medium align-self-start flex">Teaching Qualifications</label>
                    <div class="grid mt-2 gap-1  flex justify-content-center">
                        <div v-for="(cert, index) in userProfile.teachingQualifications" :key="'qual-' + index"
                            class="col-12 md:col-6">
                            <div class="grid">
                                <div class="col-6 flex align-items-center">
                                    <span class="Label">{{ cert.qualification }}</span>
                                </div>
                                <div class="col-6 flex align-items-center" v-if="cert.certificateURL">
                                    <Button label="Uploaded" class="teal-button-transparent"
                                        @click="downloadByUrl(cert.certificateURL)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <label class="Paragraph-Medium align-self-start flex">Notable Achievements & Certifications</label>
                    <div class="grid mt-2 gap-1  flex justify-content-center">
                        <div v-for="(cert, index) in userProfile.notableAchievements" :key="index"
                            class="col-12 md:col-6">
                            <div class="grid">
                                <div class="col-6 flex align-items-center">
                                    <span class="Label">{{ cert.achievement }}</span>
                                </div>
                                <div class="col-6 flex align-items-center" v-if="cert.uploadURL">
                                    <Button label="Uploaded" class="teal-button-transparent"
                                        @click="downloadByUrl(cert.uploadURL)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h2 class="H5-SemiBold mt-8 mb-4 text-center">ID verification</h2>
            <div class="grid w-full">
                <div class="flex flex-column  col-12 justify-content gap-2 pt-4">
                    <h4 class="Paragraph-Medium text-left">Uploaded Documents</h4>
                    <div class="flex flex-column md:flex-row  gap-4 justify-content-start pt-4 ">
                        <label class="Label align-self-center text-left md:col-4" for="prfPhoto">Professional
                            photo:</label>
                        <InputText v-model="userProfile.professionalPhotoURL" size="small" inputId="prfPhoto" disabled
                            variant="filled" class="w-full" />
                        <Button :label="userProfile.professionalPhotoURL ? 'Uploaded' : 'Uploaded'"
                            :disabled="!userProfile.professionalPhotoURL" class="teal-button-transparent"
                            @click="downloadByUrl(userProfile.professionalPhotoURL)"
                            :icon="userProfile.professionalPhotoURL ? 'pi pi-check' : 'pi pi-times'" />
                    </div>
                    <div class="flex gap-4 flex-column md:flex-row  justify-content-start pt-4">
                        <label class="Label  align-self-center text-left md:col-4" for="nic">NIC:</label>
                        <InputText v-model="userProfile.NICURL" size="small" inputId="nic" disabled variant="filled"
                            class="w-full" />
                        <Button :label="userProfile.NICURL ? 'Uploaded' : 'Uploaded'" :disabled="!userProfile.NICURL"
                            class="teal-button-transparent" @click="downloadByUrl(userProfile.NICURL)"
                            :icon="userProfile.NICURL ? 'pi pi-check' : 'pi pi-times'" />
                    </div>
                    <div class="flex gap-4 flex-column md:flex-row  justify-content-start pt-4">
                        <label class="Label  align-self-center text-left md:col-4" for="drivingLicence">Driving
                            License(Optional):</label>
                        <InputText v-model="userProfile.drivingLicenseURL" size="small" disabled
                            inputId="drivingLicence" variant="filled" class="w-full" />
                        <Button :label="userProfile.drivingLicenseURL ? 'Uploaded' : 'Uploaded'"
                            :disabled="!userProfile.drivingLicenseURL" class="teal-button-transparent"
                            @click="downloadByUrl(userProfile.drivingLicenseURL)"
                            :icon="userProfile.drivingLicenseURL ? 'pi pi-check' : 'pi pi-times'" />
                    </div>
                </div>
            </div>
            <div class="flex flex-column align-items-center justify-content-center pt-8">
                <div class="flex gap-2 mb-2 col-12 align-items-center">
                    <Checkbox v-model="informationAccurate" binary inputId="infoAccurate" class="teal-checkbox" />
                    <label class="Label text-left" for="infoAccurate">
                        I confirm that all information provided is accurate and complete
                    </label>
                </div>
                <div class="flex col-12 flex align-items-center gap-2 mb-2">
                    <Checkbox v-model="backgroundVerify" binary inputId="bgVerify" class="teal-checkbox" />
                    <label class="Label text-left" for="bgVerify">
                        I consent to background verification
                    </label>
                </div>
            </div>
            <div class="col-12 col-6 flex flex-wrap justify-content-between p-0">
                <div class="align-items-center al gap-3">
                    <Button label="Back" class="teal-button-transparent mt-6" @click="Cancel" />
                </div>
                <div class="align-items-center gap-3">
                    <Button label="Submit application" class="teal-button mt-6" @click="Submit"
                        :disabled="!informationAccurate || !backgroundVerify" />
                </div>
            </div>
        </Form>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, defineEmits } from "vue";
import { Form } from "@primevue/forms";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Select from "primevue/select";
import { gender, languages, availabilityOptions } from "@/utils/options";
import DatePicker from 'primevue/datepicker';
import Textarea from 'primevue/textarea';
import NationalitySelect from '@/components/common/NationalitySelect.vue';
// import RadioButton from 'primevue/radiobutton';
// import RadioButtonGroup from 'primevue/radiobuttongroup';
import Checkbox from 'primevue/checkbox';
import CheckboxGroup from 'primevue/checkboxgroup';
import { getProfile } from "@/api/tutor";
import { generateSignedUrl } from "@/api/storage";
import { cleanupLables } from "@/utils/cleanups";

const emit = defineEmits(["submit-for-verification", "previous-step"]);
const date = ref(null);
const selectGender = ref(null);
const selectedClassType = ref([]);
const userProfile = ref(null);
const fetchingData = ref(true);
const informationAccurate = ref(false);
const backgroundVerify = ref(false);
const canShow = computed(() => {
    return userProfile.value && !fetchingData.value
});

const groupedTeachingLevels = computed(() => {
    if (!userProfile.value?.teachingLevels) return [];
    const map = {};
    userProfile.value.teachingLevels.forEach(entry => {
        if (!map[entry.grade]) map[entry.grade] = { grade: entry.grade, entries: [] };
        map[entry.grade].entries.push(entry);
    });
    return Object.values(map);
});

const formatPrice = (amount) => {
    if (amount == null) return '-';
    return new Intl.NumberFormat('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
};
const Cancel = () => {
    emit("previous-step");
};

const Submit = () => {
    emit("submit-for-verification", {
        informationAccurate: informationAccurate.value,
        backgroundVerify: backgroundVerify.value,
    });
}

const downloadByUrl = async (url) => {
    const res = await generateSignedUrl(url);
    const signedUrl = res;

    const link = document.createElement('a');
    link.href = signedUrl;
    link.download = url || 'download';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
onMounted(async () => {
    fetchingData.value = true;
    const profile = await getProfile();
    userProfile.value = profile.data.data;
    selectGender.value = gender.find(g => g.value === userProfile.value.gender) || null;
    selectedClassType.value = userProfile.value.classMode === "both" ? "online and physical" : userProfile.value.classMode;
    date.value = new Date(userProfile.value.dateOfBirth);
    fetchingData.value = false;
})

// const capitalizeFirstLetter = (str) => {
//     if (!str) return '';
//     return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
// }
</script>

<style scoped>
.form {
    width: 100%;
    min-width: 60vw;
    max-width: 65vW;
}

@media (max-width: 768px) {
    .form {
        min-width: none;
    }
}

.teaching-table {
    width: 100%;
}

.teaching-grade-block {
    padding-left: 0.5rem;
}

.teaching-row {
    display: grid;
    grid-template-columns: 7rem 10rem 1fr;
    gap: 0.5rem;
    padding: 0.2rem 0;
    align-items: start;
}

.teaching-col-grade {
    padding-top: 0.15rem;
}

.teaching-col-subject {
    padding-top: 0.15rem;
}

.teaching-col-price {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}

.price-line {
    display: flex;
    gap: 0.75rem;
}

.price-type {
    min-width: 5.5rem;
}

.price-value {
    white-space: nowrap;
}

@media (max-width: 600px) {
    .teaching-row {
        grid-template-columns: 5rem 1fr;
        grid-template-rows: auto auto;
    }

    .teaching-col-price {
        grid-column: 2;
    }
}
</style>
